type Props = {
  url: string;
  filename?: string;
};

export function downloadFile({ url, filename }: Props) {
  const anchorElement = document.createElement('a');
  anchorElement.href = url;
  anchorElement.setAttribute('download', filename ?? '');
  anchorElement.click();
}
